import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DashboardComponent } from "../dashboard/dashboard.component";
import { LoginApiService } from "../../services/api/login-api.service";
//import {UserModel} from 'src/app/models/user.model';
import { environment } from "src/environments/environment";
import { UsersService } from "src/app/services/users/users.service";
import { logoLogin } from "src/app/config/imagenes";
import { ImageConfigService } from "src/app/services/image-config/image-config.service";
import { StorageManager } from "src/app/common/storage-manager.class";
import { UserModel } from "src/app/models/user.model";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers: [UsersService],
})
export class LoginComponent implements OnInit {
  public error: boolean = false;
  /*   public logoUrl: string = environment.logoUrl; */
  public logoUrl: boolean = true;
  public password: string;
  public isDoLoginLoading: boolean;
  public errorMsg: string;
  // public logo: string = logoLogin;
  public logo: string;

  public userList: any = {
    selected: null,
    /*  values: [
            {label: '...', value: {id: ''}},
            {label: 'Casado, Carlos', value: {id: 0, password: '1234', name: 'Casado, Carlos'}},
            {label: 'Invitado', value: {id: 1, password: '1234', name: 'Invitado'}},
            {label: 'Admin', value: {id: 2, password: 'admin', name: 'Admin'}},
        ] */
    values: [
      { label: "...", value: { id: "" } },
      //{label: 'Casado, Carlos', value: {id: 0,  name: 'Casado, Carlos'}},
    ],
  };

  public static createNavigation(router: Router) {
    router.navigate(["login"]);
  }

  constructor(
    private router: Router,
    private loginApi: LoginApiService,
    private userServiceLogin: UsersService,
    private imageConfigService: ImageConfigService
  ) {}

  ngOnInit() {
    let datos = JSON.parse(localStorage.getItem("calidad_last_user_tag_1"));

    if (datos) {
      let nombre: string = datos.name;

      if (environment.appName === "campanaragricola") {
        this.imageConfigService.updateImages("LOCATEC");
      } else {
        this.imageConfigService.updateImages(nombre);
      }

      this.imageConfigService.currentLogoDashboard.subscribe(
        (logo) => (this.logo = logo)
      );
    }

    // this.userServiceLogin.getAllUsers().subscribe((data:any)=>{
    //    // console.log("users",data);
    //     data.sort((a, b) =>  a.nombre.localeCompare(b.nombre));

    //     for (let index = 0; index < data.length; index++) {
    //         const element = {label:data[index].nombre,value: {id: data[index].idUser,  name: data[index].nombre}}
    //         this.userList['values'].push(element);

    //     }

    // },error=>{
    //     console.log("error",error);
    // });

    this.userServiceLogin.getAllUsernames().subscribe(
      (data: any) => {
        console.log(data);
        data.sort((a, b) => a.nombre.localeCompare(b.nombre));

        for (let index = 0; index < data.length; index++) {
          const element = {
            label: data[index].nombre,
            value: { id: data[index].idUser, name: data[index].nombre },
          };
          this.userList["values"].push(element);
        }
      },
      (error) => {
        console.log("error", error);
      }
    );

    /*this.loginApi.getUsers()
            .then((userList: UserModel[]) => {
                this.userList.values = [];

                this.userList.values.push({
                    label: 'Seleccionar usuario...',
                    value: {id: null}
                });

                userList.forEach(user => {
                    this.userList.values.push({
                        label: (user.nombre || '') + ' ' + (user.apellidos || ''),
                        value: user
                    } as any);
                });
            });*/

    if (environment.appName === "campanaragricola") {
      localStorage.setItem("role", "ROLE_ADMIN");

      const fakeUser: UserModel = {
        id: "1",
        nombre: "Campanar Agricola",
        apellidos: "Agricola",
        password: "1234",
        rol: "ROLE_ADMIN",
        username: "Campanar",
      };
      this.loginApi.doLogin(fakeUser).then(() => {
        DashboardComponent.createNavigation(this.router);
      });

      // localStorage.setItem("role","ROLE_ADMIN");
      // localStorage.setItem("calidad_user_tag_1", "Campanar Agricola");
      // localStorage.setItem("calidad_last_user_tag_1", "Campanar Agricola");

      // console.log('App campanaragricola, login');
      // console.log(this.router)
      // DashboardComponent.createNavigation(this.router);

      return;
    }

    this.loginApi.checkCurrentSession().then((exists: Boolean) => {
      if (exists) {
        DashboardComponent.createNavigation(this.router);
      }
    });
  }

  public setUser(user) {
    this.userList.selected = user;
  }

  // public doLogin(pass) {
  //     this.isDoLoginLoading = true;

  //     let myuser:any={
  //         "nombre":this.userList.selected.value.name,
  //         "password":pass.value
  //     };
  //     //console.log(myuser);
  //     this.userServiceLogin.loginUsers(myuser).subscribe((resp:any)=>{
  //         //console.log(resp);

  //         console.log

  //         if(resp != null){
  //             if(resp.role != null && resp.role == "ROLE_ADMIN" ) {
  //                 localStorage.setItem("role","ROLE_ADMIN");
  //             } else {
  //                 localStorage.setItem("role",resp.role);
  //             }
  //             if(resp.readonly != null ) {
  //                 if ( (resp.readonly as string).localeCompare('1') == 0 ) {
  //                     localStorage.setItem("readonly","1");
  //                 } else {
  //                     localStorage.setItem("readonly","0");
  //                 }

  //             }
  //             localStorage.setItem("documentos",JSON.stringify(resp.documentos));
  //             if (this.userList.selected) {
  //                 this.errorMsg = "";

  //                 this.loginApi.doLogin(this.userList.selected.value)
  //                     .then((isValid: boolean) => {
  //                         if(isValid){
  //                             this.imageConfigService.updateImages(this.userList.selected.value.name)
  //                             DashboardComponent.createNavigation(this.router)
  //                         }else{
  //                             this.error = true
  //                         }
  //                         this.isDoLoginLoading = false;
  //                     })
  //                     .catch((error: Response) => {
  //                         console.log(error)
  //                         this.error = true;
  //                         this.isDoLoginLoading = false;
  //                     })
  //             }else{
  //                 console.log("Invalid pass");
  //                 this.errorMsg = "Contraseña incorrecta!";
  //                 this.isDoLoginLoading = false;
  //             }
  //         }else{
  //             console.log("Invalid pass");
  //             this.errorMsg = "Contraseña incorrecta!";
  //             this.isDoLoginLoading = false;
  //         }
  //     },error=>{
  //         console.log("error",error);
  //     });
  //     //this.userServiceLogin.loginUsers();
  //    let passw = pass.value;

  // }
  public doLogin(pass) {
    if (environment.appName === "campanaragricola") {
      localStorage.setItem("role", "ROLE_ADMIN");

      const fakeUser: UserModel = {
        id: "1",
        nombre: "Campanar Agricola",
        apellidos: "Agricola",
        password: "1234",
        rol: "ROLE_ADMIN",
        username: "Campanar",
      };
      this.loginApi.doLogin(fakeUser).then(() => {
        DashboardComponent.createNavigation(this.router);
      });

      // localStorage.setItem("role","ROLE_ADMIN");
      // localStorage.setItem("calidad_user_tag_1", "Campanar Agricola");
      // localStorage.setItem("calidad_last_user_tag_1", "Campanar Agricola");

      // console.log('App campanaragricola, login');
      // console.log(this.router)
      // DashboardComponent.createNavigation(this.router);

      return;
    }

    let myuser: any = {
      nombre: this.userList.selected.value.name,
      password: pass.value,
    };

    this.errorMsg = "";
    this.isDoLoginLoading = true;

    this.userServiceLogin.newLoginUsers(myuser).subscribe(
      (resp: any) => {
        
        resp = { ...resp, success: true }

        if (resp.success === true) {
          resp = resp[0]
          console.log(resp)
          if (resp.role != null && resp.role == "ROLE_ADMIN") {
            
            localStorage.setItem("role", "ROLE_ADMIN");
          } else {
            localStorage.setItem("role", resp.role);
          }
          if (resp.readonly != null) {
            if ((resp.readonly as string).localeCompare("1") == 0) {
              localStorage.setItem("readonly", "1");
            } else {
              localStorage.setItem("readonly", "0");
            }
          }
          localStorage.setItem(
            "documentos",
            JSON.stringify(resp.documentos)
          );
          
          if (this.userList.selected) {
            this.errorMsg = "";

            this.loginApi
              .doLogin(this.userList.selected.value)
              .then((isValid: boolean) => {
                if (isValid) {
                  this.saveLog(this.userList.selected.value);
                  this.imageConfigService.updateImages(
                    this.userList.selected.value.name
                  );
                  DashboardComponent.createNavigation(this.router);
                } else {
                  this.error = true;
                }
                this.isDoLoginLoading = false;
              })
              .catch((error: Response) => {
                console.log(error);
                this.error = true;
                this.isDoLoginLoading = false;
              });
          } else {
            console.log("Invalid pass");
            this.errorMsg = resp.message;
            this.isDoLoginLoading = false;
          }
        } else {
          this.errorMsg = resp.message;
          this.isDoLoginLoading = false;
        }
      },
      (error) => {
        console.log("error", error);
        this.errorMsg = error;
        this.isDoLoginLoading = false;
      }
    );
  }

  public saveLog(data){
    this.userServiceLogin.saveLog({"nombre": data.name}).toPromise().then(res => console.log(res));

  }
}
